import { FC, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useDueDateAttachmentApi } from "../../http/dueDateAttachments/api";
import ModalDialog from "../ui/ModalDialog";

type DeleteDueDateAttachmentDialogProps = {
  dueDateAttachmentId: string;
  dueDateId: string;
  onClose: () => void;
};

const DeleteDueDateAttachmentDialog: FC<DeleteDueDateAttachmentDialogProps> = ({
  dueDateAttachmentId,
  dueDateId,
  onClose,
}) => {
  const i18n = useI18n();
  const dueDateAttachmentsApi = useDueDateAttachmentApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.documents.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: async () => {
            setIsSubmitting(true);
            await dueDateAttachmentsApi
              .deleteDueDateAttachment(dueDateAttachmentId, dueDateId)
              .then(onClose)
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.documents.questions.delete}
    </ModalDialog>
  );
};

export default DeleteDueDateAttachmentDialog;
